module.exports = __webpack_public_path__ + "static/media/coupon-redeemed-stamp.e9c360dc.svg";